import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfig } from '../../../components/modals/app-config/app.config';
import { environment } from '../../../../environments/environment';

export interface WidgetRuntimeConfig {
  browserTabTitle: string;
  humanAgentFeature: boolean;
  humanAgentSessionClosedMessage: string;
}

const DEFAULTS: WidgetRuntimeConfig = {
  browserTabTitle: environment.browserTabTitle,
  humanAgentFeature: environment.humanAgentFeature,
  humanAgentSessionClosedMessage: environment.humanAgentSessionClosedMessage,
};

@Injectable({
  providedIn: 'root',
})
export class RuntimeConfigService {
  private readonly configSubject = new BehaviorSubject<WidgetRuntimeConfig>({
    ...DEFAULTS,
  });

  readonly config$ = this.configSubject.asObservable();

  get snapshot(): WidgetRuntimeConfig {
    return this.configSubject.getValue();
  }

  applyFromAppConfigs(configs: AppConfig[]): void {
    const next: WidgetRuntimeConfig = { ...DEFAULTS };

    for (const config of configs) {
      switch (config.name) {
        case 'BROWSER_TAB_TITLE':
          if (config.value?.trim()) {
            next.browserTabTitle = config.value.trim();
          }
          break;
        case 'HUMAN_AGENT_FEATURE_ENABLED':
          next.humanAgentFeature = config.value === 'true';
          break;
        case 'HUMAN_AGENT_SESSION_CLOSED_MESSAGE':
          if (config.value?.trim()) {
            next.humanAgentSessionClosedMessage = config.value.trim();
          }
          break;
        default:
          break;
      }
    }

    this.configSubject.next(next);
  }
}
